/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-04 20:23:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/tools/advancedPrice.ts
 */
import _ from 'lodash';
export const checkAdvancedPrice = (advancedPriceSettings) => {
  const data = _.cloneDeep(advancedPriceSettings || []);
  const flag = false;
  data.forEach((i) => {
    // const { price } = i || {};
    // if (!title) {
    //   i.titleError = true;
    //   flag = true;
    // }
    // if (!price) {
    //   i.priceError = true;
    //   flag = true;
    // }
    // if (!currency) {
    //   i.currencyError = true;
    //   flag = true;
    // }
  });
  return { flag, data };
};
